



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import accordion from '@/core/ui-components/Accordion.vue';
import { MenuItem } from '@/types/apiServerContract';
import CategoryNameAndCount from '@/project/search/navigation/CategoryNameAndCount.vue';

@Component({
    components: { CategoryNameAndCount, accordion }
})
export default class CategoryNavigation extends Vue {
    @Prop({ required: false, type: Object })
    private readonly rootMenuItem!: MenuItem | null;

    @Prop({ required: false, type: Object })
    private activeMenuItem!: MenuItem | null;

    @Prop({ required: false, type: String })
    private campaignCode!: string | null;

    @Prop({ required: false, type: String })
    private campaignName!: string | null;

    @Prop({ type: Array, required: true })
    private menuItems!: readonly MenuItem[];

    private get menuItemsOrRoot() {
        return this.rootMenuItem ? this.rootMenuItem.children : this.menuItems;
    }

    private get query() {
        return this.$route.query;
    }
}
